import React, { Component } from "react";
import ZPartner01GrabHeader from "./ZPartner01GrabHeader";
import ZPartner01GrabFooter from "./ZPartner01GrabFooter";

export class ZPartner01MemberNewStep01Thx extends Component {
    static displayName = ZPartner01MemberNewStep01Thx.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }    
    
    render() {                           
        return (
            <>
                <ZPartner01GrabHeader />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">                            
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <div className="row mb-4">
                                            <div className="column size1of12 p0"><img src="media/icons/icon-preview.webp" alt="" className="img" width={40} /></div>
                                            <div className="column size11of12 p0 pl2">
                                                กรุณาค้างหน้าจอนี้ไว้<br />
                                                Please stay on this page.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="column size1of12 p0"><img src="media/icons/icon-pngegg.webp" alt="" className="img" width={40} /></div>
                                            <div className="column size11of12 p0 pl2">
                                                ตรวจสอบอีเมลของคุณ และกด verification link<br />
                                                Check your email and click on verification link.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="column size1of12 p0"><img src="media/icons/icon-junk.webp" alt="" className="img" width={40} /></div>
                                            <div className="column size11of12 p0 pl2">
                                                หากไม่ได้รับอีเมล กรุณาตรวจสอบใน Spam Mail Box หรือ Junk Mail Box ของคุณ<br />
                                                Check your Spam or Junk folder to ensure the message was not filtered.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="column size1of12 p0"><img src="media/icons/icon-grab.webp" alt="" className="img" width={40} style={{ WebkitBorderRadius: '7px', MozBorderRadius: '7px', borderRadius: '7px' }} /></div>
                                            <div className="column size11of12 p0 pl2">
                                                เมื่อสร้างบัญชีเรียบร้อยแล้ว ให้ไปที่ Grab แอป <br />
                                                Go to Grab app after completing your registration.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="column size1of12 p0"><img src="media/icons/icon-check.webp" alt="" className="img" width={40} /></div>
                                            <div className="column size11of12 p0 pl2">
                                                บนหน้าสรุปคำสั่งซื้อจะมีเครื่องหมายถูกสีเขียวปรากฏอยู่ที่หลังคำว่า “Membership”<br />
                                                Green check mark will appear after "Membership" on Order Summary page.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </section>
                </main>

                <ZPartner01GrabFooter />
            </>            
        );
    }
}
